export default __webpack_public_path__ + "static/media/spring.8c6dcd7f.png";